import { c as _c } from "react/compiler-runtime";
import { IoStarSharp } from 'react-icons/io5';
export const RatingStars = t0 => {
  const $ = _c(22);
  const {
    rating,
    outOf: t1,
    size: t2
  } = t0;
  const outOf = t1 === undefined ? 5 : t1;
  const size = t2 === undefined ? 5 : t2;
  if (typeof rating === "undefined" || rating <= 0 || rating > outOf) {
    return null;
  }
  let fullStars = Math.floor(rating);
  const hasHalf = rating - fullStars >= 0.25 && rating - fullStars <= 0.75;
  if (rating - fullStars > 0.75) {
    fullStars = Math.ceil(rating);
  }
  const emptyStars = outOf - fullStars - (hasHalf ? 1 : 0);
  const t3 = `${rating} out of ${outOf} stars`;
  let t4;
  if ($[0] !== outOf || $[1] !== rating) {
    t4 = <span className="sr-only">{rating} out of {outOf} stars</span>;
    $[0] = outOf;
    $[1] = rating;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== fullStars) {
    t5 = [...Array(fullStars)];
    $[3] = fullStars;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== size || $[6] !== t5) {
    t6 = t5.map((_, i) => <IoStarSharp key={`full-${i}`} className={`size-${size} text-yellow-500`} aria-hidden="true" />);
    $[5] = size;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== hasHalf || $[9] !== size) {
    t7 = hasHalf && <span className={`relative size-${size}`} key="half" aria-hidden="true"><IoStarSharp className={`size-${size} absolute top-0 left-0 text-yellow-500`} style={{
        clipPath: "inset(0 50% 0 0)"
      }} aria-hidden="true" /><IoStarSharp className={`size-${size} absolute top-0 left-0 text-zinc-300 dark:text-zinc-500`} style={{
        clipPath: "inset(0 0 0 50%)"
      }} aria-hidden="true" /></span>;
    $[8] = hasHalf;
    $[9] = size;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== emptyStars) {
    t8 = [...Array(emptyStars)];
    $[11] = emptyStars;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== size || $[14] !== t8) {
    t9 = t8.map((__0, i_0) => <IoStarSharp key={`empty-${i_0}`} className={`size-${size} text-zinc-300 dark:text-zinc-500`} aria-hidden="true" />);
    $[13] = size;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6 || $[19] !== t7 || $[20] !== t9) {
    t10 = <div className="mb-0.5 flex items-center" title={t3}>{t4}{t6}{t7}{t9}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};